import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import { errorMessage } from '../constants/errorMessage'
// import {comingSoon} from '../assets/img/comingsoon.svg'
import comingSoon from '../assets/img/commingsoon.svg'
function ComingSoon() {
    useEffect(() => {
        window.scrollTo(0,0)
    })
    return (
        <div className='d-flex align-items-center h100vh'>
            <img src={comingSoon} alt='' width={'100%'}/>       
        </div>
    )
}

ComingSoon.propTypes = {
    message: PropTypes.string
}

ComingSoon.defaulProps = {
    message: undefined,
}

export default connect()(ComingSoon)